/* eslint-disable import/prefer-default-export */
import styled, { css } from "styled-components";

const innerPadding = 15;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
`;

const HeaderAndFooterBaseStyle = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  transition: box-shadow 200ms;
  padding: ${innerPadding}px;
  background-color: #e0e0e0;
`;

export const Header = styled(HeaderAndFooterBaseStyle)`
  border-bottom: 1px solid hsl(0, 0%, 80%);
`;
export const Footer = styled(HeaderAndFooterBaseStyle)`
  border-top: 1px solid hsl(0, 0%, 80%);
`;

export const Title = styled.h4`
  align-items: center;
  display: flex;
  margin: 0;
`;

export const TitleIconWrapper = styled.i`
  margin-right: 3px;
`;

export const Body = styled.div`
  flex: 1 1 auto;
  padding: ${innerPadding}px;
  ${props =>
    props.shouldScroll
      ? css`
          overflow-y: auto;
        `
      : null};
`;

export const Actions = styled.div`
  display: inline-flex;
  margin: 0;
`;

export const ActionItem = styled.div`
  flex: 1 0 auto;
  margin: 0 3px;
`;
